import React from 'react';
import type { RouteObject } from 'react-router-dom';
import { RequireRole } from './RouteGuards';
import {
  AdminAiConfig,
  AdminDashboard,
  AdminErrorLogs,
  AdminFeTelemetryLogs,
  AdminMaterializedViews,
  AdminRoles,
  AdminSystem,
  AdminTtsAudioCache,
  AdminUserAccountLink,
  AdminUserAccountLinkDetail,
  AuditLogs,
  StudentClassrooms,
  StudentsList,
  StudentsProgress,
  UserDetail,
  UserDashboard,
} from './lazyPages';

export const adminUserRoutes: RouteObject[] = [
  {
    path: 'admin/users/:id',
    element: (
      <React.Suspense fallback={null}>
        <UserDetail />
      </React.Suspense>
    ),
  },
  {
    path: 'admin/users/:id/dashboard',
    element: (
      <RequireRole role="ADMIN">
        <React.Suspense fallback={null}>
          <UserDashboard />
        </React.Suspense>
      </RequireRole>
    ),
  },
  {
    path: 'admin',
    element: (
      <RequireRole role="ADMIN">
        <React.Suspense fallback={null}>
          <AdminDashboard />
        </React.Suspense>
      </RequireRole>
    ),
  },
];

export const adminStudentClassroomRoutes: RouteObject[] = [
  {
    path: 'students/:studentId/classrooms',
    element: (
      <RequireRole role="ADMIN">
        <React.Suspense fallback={null}>
          <StudentClassrooms />
        </React.Suspense>
      </RequireRole>
    ),
  },
];

export const adminStudentRoutes: RouteObject[] = [
  {
    path: 'students',
    element: (
      <RequireRole role="ADMIN">
        <React.Suspense fallback={null}>
          <StudentsList />
        </React.Suspense>
      </RequireRole>
    ),
  },
  {
    path: 'students/progress',
    element: (
      <RequireRole role="ADMIN">
        <React.Suspense fallback={null}>
          <StudentsProgress />
        </React.Suspense>
      </RequireRole>
    ),
  },
];

export const adminSystemRoutes: RouteObject[] = [
  {
    path: 'admin/users/account-links',
    element: (
      <RequireRole role="ADMIN">
        <React.Suspense fallback={null}>
          <AdminUserAccountLink />
        </React.Suspense>
      </RequireRole>
    ),
  },
  {
    path: 'admin/users/account-links/:groupId',
    element: (
      <RequireRole role="ADMIN">
        <React.Suspense fallback={null}>
          <AdminUserAccountLinkDetail />
        </React.Suspense>
      </RequireRole>
    ),
  },
  {
    path: 'admin/roles',
    element: (
      <RequireRole role="ADMIN">
        <React.Suspense fallback={null}>
          <AdminRoles />
        </React.Suspense>
      </RequireRole>
    ),
  },
  {
    path: 'admin/roles',
    element: (
      <RequireRole role="ADMIN">
        <React.Suspense fallback={null}>
          <AdminRoles />
        </React.Suspense>
      </RequireRole>
    ),
  },
  {
    path: 'admin/system',
    element: (
      <RequireRole role="ADMIN">
        <React.Suspense fallback={null}>
          <AdminSystem />
        </React.Suspense>
      </RequireRole>
    ),
  },
  {
    path: 'admin/ai-config',
    element: (
      <RequireRole role="ADMIN">
        <React.Suspense fallback={null}>
          <AdminAiConfig />
        </React.Suspense>
      </RequireRole>
    ),
  },
  {
    path: 'admin/materialized-views',
    element: (
      <RequireRole role="ADMIN">
        <React.Suspense fallback={null}>
          <AdminMaterializedViews />
        </React.Suspense>
      </RequireRole>
    ),
  },
  {
    path: 'admin/tts-audio-cache',
    element: (
      <RequireRole role="ADMIN">
        <React.Suspense fallback={null}>
          <AdminTtsAudioCache />
        </React.Suspense>
      </RequireRole>
    ),
  },
  {
    path: 'admin/audit-logs',
    element: (
      <RequireRole role="ADMIN">
        <React.Suspense fallback={null}>
          <AuditLogs />
        </React.Suspense>
      </RequireRole>
    ),
  },
  {
    path: 'admin/error-logs',
    element: (
      <RequireRole role="ADMIN">
        <React.Suspense fallback={null}>
          <AdminErrorLogs />
        </React.Suspense>
      </RequireRole>
    ),
  },
  {
    path: 'admin/fe-telemetry-logs',
    element: (
      <RequireRole role="ADMIN">
        <React.Suspense fallback={null}>
          <AdminFeTelemetryLogs />
        </React.Suspense>
      </RequireRole>
    ),
  },
];
